module.exports = __webpack_public_path__ + "img/scene-bank.6f12aa95.png";